import React, { useState, useEffect } from 'react';
import Layout from './Layout';
import { Grid, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { url, getToken } from './_helpers'
import ReactPDF, { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import { PDFViewer } from '@react-pdf/renderer';
import { formatDate } from './_helpers'

export const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(3),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        marginBottom: '10px',
        height: '800px'
    },
    fixedHeight: {
        height: 240,
    },
}));

const styles = StyleSheet.create({
    page: {
        flexDirection: 'row',
        backgroundColor: 'white',
        padding: '20pt',
        width: '100%'
    },
    text: {
        width: "100%",
        backgroundColor: "#f0f0f0",
        color: "#212121"
    }
});

const loja = {
    SAUDE: {
        endereco: 'Rua Francisco Tapajós 149 – Saúde – São Paulo – SP',
        telefone: '(11) 5068-2783',
        email: 'saude@gbforros.com.br'
    },
    VILA_MARIA: {
        endereco: 'Rua Dias da Silva, nº 1131 – Vila Maria – São Paulo – SP',
        telefone: '(11) 2954-3736',
        email: 'vilamaria@gbforros.com.br'
    }
}

const defaultStyle = ReactPDF.Style = {
    display: 'flex',
    flexBasis: '100%',
    flexWrap: 'wrap',
    paddingTop: '5px',
    paddingBottom: '5px',
    wordWrap: "break-word",
    whiteSpace: "pre-wrap"
};

export default function PdfVenda(props) {
    let { id } = useParams();
    const [values, setValues] = useState({
        id: '',
        codigo: '',
        frete: 0,
        desconto: 0,
        pagamento: 'DINHEIRO',
        total: 0,
        data: new Date(),
        cep: '',
        endereco: '',
        numero: '',
        complemento: '',
        obs: '',
        loja: 'SAUDE',
        cliente: {
            id: 0,
            nome: '',
            cpfCnpj: '',
            celular: '',
            telefone: '',
            cep: '',
            endereco: '',
            numero: '',
            complemento: ''
        },
        produtos: [],
        servicos: [],
        informacoes: [],
        medidas: []
    });

    useEffect(() => {
        if (id)
            fetch(`${url}/venda/${id}`, {
                headers: {
                    'Authorization': `Bearer ${encodeURI(getToken().token)}`,
                }
            })
                .then(res => res.json())
                .then(
                    (result) => {
                        setValues(result)
                    },
                    (error) => {
                        console.log(error)
                    }
                )
    }, []);


    const classes = useStyles();
    return (
        <Layout>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Paper className={classes.paper}>
                        <PDFViewer style={{
                            height: '800px'
                        }}>
                            <Document title={`visita-${values.codigo}`}>
                                <Page size="A4" style={styles.page}>
                                    <View style={{ width: '100%', display: 'flex', flexDirection: 'column', height: '100%', border: "1pt solid black" }}>
                                        <View style={{
                                            flexDirection: "row",

                                            width: "100%",
                                            display: "flex"

                                        }}>
                                            <View style={{ ...defaultStyle, width: '30%', border: "1pt solid black", paddingTop: '30pt', textAlign: 'center' }}>
                                                <Image source={require('./gb-logo-site.png')} style={{ width: '40%', marginLeft: 40 }} />
                                                <Text>Forros de PVC</Text>
                                            </View>
                                            <View style={{ ...defaultStyle, width: '70%', border: "1pt solid black", textAlign: 'center', }}>
                                                <View style={{ ...defaultStyle, width: '100%', borderBottom: "1pt solid black", fontSize: '16pt' }}>
                                                    <Text>Clanil Comércio de Plasticos LTDA-ME</Text>
                                                </View>
                                                <View style={{ ...defaultStyle, width: '100%', fontSize: '10pt' }}>
                                                    <Text style={{ marginBottom: '5pt' }}>CNPJ: 09.013.810/0001-57 - IE: 149.780.989.110</Text>
                                                    <Text style={{ marginBottom: '5pt' }}>{loja[values.loja].endereco}</Text>
                                                    <Text style={{ marginBottom: '5pt' }}>{`Telefone: ${loja[values.loja].telefone}`}</Text>
                                                    <Text style={{ marginBottom: '5pt' }}>{`Website: https://gbforros.com Email: ${loja[values.loja].email}`}</Text>
                                                </View>
                                                <View style={{ ...defaultStyle, width: '100%', fontSize: '12pt', borderTop: "1pt solid black" }}>
                                                    <Text>{`Romaneio do Orçamento ${values.codigo} - Início da Obra: ${formatDate(values.data)}`}</Text>
                                                </View>
                                            </View>
                                        </View>
                                        <View style={{
                                            flexDirection: "row",
                                            justifyContent: "stretch",
                                            width: "100%",
                                            display: "flex",
                                            border: "1pt solid black"
                                        }}>

                                            <View style={{ ...defaultStyle, fontSize: '10pt', paddingLeft: '15px' }}>
                                                <Text style={{ marginBottom: '5pt', fontSize: '12pt' }}>Dados do Cliente</Text>
                                                <Text style={{ marginBottom: '5pt' }}>Nome: {values.cliente.nome}</Text>
                                                <Text style={{ marginBottom: '5pt' }}>CEP: {values.cliente.cep}</Text>
                                                <Text style={{ marginBottom: '5pt' }}>Endereço: {values.cliente.endereco}, Número: {values.cliente.numero}</Text>
                                                {!!values.cliente.complemento && <Text style={{ marginBottom: '5pt' }}>Complemento: {values.cliente.complemento}</Text>}
                                                <Text style={{ marginBottom: '5pt' }}>Celular: {values.cliente.celular} | Telefone: {values.cliente.telefone}</Text>
                                                {!!values.cliente.email && <Text style={{ marginBottom: '5pt' }}>Email: {values.cliente.email}</Text>}
                                            </View>
                                        </View>
                                        <View style={{
                                            flexDirection: "row",
                                            justifyContent: "stretch",
                                            width: "100%",
                                            display: "flex",
                                            border: "1pt solid black"
                                        }}>
                                            <View style={{ ...defaultStyle, fontSize: '10pt', paddingLeft: '15px' }}>
                                                <Text style={{ marginBottom: '5pt', fontSize: '12pt' }}>Dados da obra</Text>
                                                <Text style={{ marginBottom: '5pt' }}>CEP: {values.cep}</Text>
                                                <Text style={{ marginBottom: '5pt' }}>Endereço: {values.endereco}, Número: {values.numero}</Text>
                                                {!!values.complemento && <Text style={{ marginBottom: '5pt' }}>Complemento: {values.complemento}</Text>}
                                            </View>
                                        </View>
                                        <View style={{
                                            flexDirection: "row",
                                            width: "100%",
                                            display: "flex",
                                            border: "1pt solid black"
                                        }}>
                                            <View style={{ ...defaultStyle, width: '10%', fontSize: '10pt', fontWeight: '700', paddingLeft: '5px', textAlign: 'left', borderRight: "1pt solid black" }}>
                                                <Text style={{ marginBottom: '2pt' }}>IT</Text>
                                            </View>
                                            <View style={{ ...defaultStyle, width: '10%', fontSize: '10pt', fontWeight: '700', paddingLeft: '5px', textAlign: 'left', borderRight: "1pt solid black" }}>
                                                <Text style={{ marginBottom: '2pt' }}>Código</Text>
                                            </View>
                                            <View style={{ ...defaultStyle, width: '65%', fontSize: '10pt', fontWeight: '700', paddingLeft: '5px', textAlign: 'left', borderRight: "1pt solid black" }}>
                                                <Text style={{ marginBottom: '2pt' }}>Descrição</Text>
                                            </View>
                                            <View style={{ ...defaultStyle, width: '15%', fontSize: '10pt', fontWeight: '700', paddingLeft: '5px', textAlign: 'left', borderRight: "1pt solid black" }}>
                                                <Text style={{ marginBottom: '2pt' }}>Quantidade</Text>
                                            </View>
                                        </View>
                                        {values.produtos.map((produto, i) => {
                                            return (
                                                <View style={{
                                                    flexDirection: "row",
                                                    width: "100%",
                                                    display: "flex",
                                                    border: "1pt solid black"
                                                }} key={i}>
                                                    <View style={{ ...defaultStyle, width: '10%', fontSize: '10pt', paddingLeft: '5px', textAlign: 'left', borderRight: "1pt solid black" }}>
                                                        <Text style={{ marginBottom: '2pt' }}>{i + 1}</Text>
                                                    </View>
                                                    <View style={{ ...defaultStyle, width: '10%', fontSize: '10pt', paddingLeft: '5px', textAlign: 'left', borderRight: "1pt solid black" }}>
                                                        <Text style={{ marginBottom: '2pt' }}>{produto.codigo}</Text>
                                                    </View>
                                                    <View style={{ ...defaultStyle, width: '65%', fontSize: '10pt', paddingLeft: '5px', textAlign: 'left', borderRight: "1pt solid black" }}>
                                                        <Text style={{ marginBottom: '2pt' }}>{produto.descricao}</Text>
                                                    </View>
                                                    <View style={{ ...defaultStyle, width: '15%', fontSize: '10pt', paddingLeft: '5px', textAlign: 'left', borderRight: "1pt solid black" }}>
                                                        <Text style={{ marginBottom: '2pt' }}>{produto.qnt}</Text>
                                                    </View>
                                                </View>
                                            )
                                        })}
                                        <View style={{
                                            flexDirection: "row",
                                            justifyContent: "stretch",
                                            width: "100%",
                                            display: "flex",
                                            border: "1pt solid black"
                                        }}>
                                            <View style={{ ...defaultStyle, width: '100%', fontSize: '16pt', fontWeight: '700', paddingLeft: '15px', textAlign: 'center' }}>
                                                <Text style={{ marginBottom: '5pt' }}>Medidas</Text>
                                            </View>
                                        </View>
                                        <View style={{
                                            flexDirection: "row",
                                            width: "100%",
                                            display: "flex",
                                            border: "1pt solid black"
                                        }}>
                                            <View style={{ ...defaultStyle, width: '10%', fontSize: '12pt', fontWeight: '700', paddingLeft: '5px', textAlign: 'left', borderRight: "1pt solid black" }}>
                                                <Text style={{ marginBottom: '2pt' }}>IT</Text>
                                            </View>
                                            <View style={{ ...defaultStyle, width: '45%', fontSize: '12pt', fontWeight: '700', paddingLeft: '5px', textAlign: 'left', borderRight: "1pt solid black" }}>
                                                <Text style={{ marginBottom: '2pt' }}>Ambiente</Text>
                                            </View>
                                            <View style={{ ...defaultStyle, width: '45%', fontSize: '12pt', fontWeight: '700', paddingLeft: '5px', textAlign: 'left', borderRight: "1pt solid black" }}>
                                                <Text style={{ marginBottom: '2pt' }}>Metragem</Text>
                                            </View>
                                        </View>
                                        {values.medidas.map((medida, i) => {
                                            return (
                                                <View style={{
                                                    flexDirection: "row",
                                                    width: "100%",
                                                    display: "flex",
                                                    border: "1pt solid black"
                                                }} key={i}>
                                                    <View style={{ ...defaultStyle, width: '10%', fontSize: '10pt', paddingLeft: '5px', textAlign: 'left', borderRight: "1pt solid black" }}>
                                                        <Text style={{ marginBottom: '2pt' }}>{i + 1}</Text>
                                                    </View>
                                                    <View style={{ ...defaultStyle, width: '45%', fontSize: '10pt', paddingLeft: '5px', textAlign: 'left', borderRight: "1pt solid black" }}>
                                                        <Text style={{ marginBottom: '2pt' }}>{medida.ambiente}</Text>
                                                    </View>
                                                    <View style={{ ...defaultStyle, width: '45%', fontSize: '10pt', paddingLeft: '5px', textAlign: 'left', borderRight: "1pt solid black" }}>
                                                        {!!medida.metragem ? (<Text style={{ marginBottom: '2pt' }}>{medida.metragem}</Text>) :
                                                            (<Text style={{ marginBottom: '2pt' }}>{medida.largura} x {medida.comprimento}</Text>)}
                                                    </View>
                                                </View>
                                            )
                                        })}
                                    </View>
                                </Page>
                                <Page size="A4" style={styles.page}>
                                    <View style={{ width: '100%', display: 'flex', flexDirection: 'column', height: '100%', border: "1pt solid black" }}>
                                        <View style={{
                                            flexDirection: "row",

                                            width: "100%",
                                            display: "flex"

                                        }}>
                                            <View style={{ ...defaultStyle, width: '30%', border: "1pt solid black", paddingTop: '30pt', textAlign: 'center' }}>
                                                <Image source={require('./gb-logo-site.png')} style={{ width: '40%', marginLeft: 40 }} />
                                                <Text>Forros de PVC</Text>
                                            </View>
                                            <View style={{ ...defaultStyle, width: '70%', border: "1pt solid black", textAlign: 'center', }}>
                                                <View style={{ ...defaultStyle, width: '100%', borderBottom: "1pt solid black", fontSize: '16pt' }}>
                                                    <Text>Clanil Comércio de Plasticos LTDA-ME</Text>
                                                </View>
                                                <View style={{ ...defaultStyle, width: '100%', fontSize: '10pt' }}>
                                                    <Text style={{ marginBottom: '5pt' }}>CNPJ: 09.013.810/0001-57 - IE: 149.780.989.110</Text>
                                                    <Text style={{ marginBottom: '5pt' }}>{loja[values.loja].endereco}</Text>
                                                    <Text style={{ marginBottom: '5pt' }}>{`Telefone: ${loja[values.loja].telefone}`}</Text>
                                                    <Text style={{ marginBottom: '5pt' }}>{`Website: https://gbforros.com Email: ${loja[values.loja].email}`}</Text>
                                                </View>
                                                <View style={{ ...defaultStyle, width: '100%', fontSize: '14pt', borderTop: "1pt solid black" }}>
                                                    <Text>{`${values.codigo} - Data: ${formatDate(values.data)}`}</Text>
                                                </View>
                                            </View>
                                        </View>
                                        <View style={{
                                            flexDirection: "row",
                                            justifyContent: "stretch",
                                            width: "100%",
                                            display: "flex",
                                            border: "1pt solid black"
                                        }}>

                                            <View style={{ ...defaultStyle, fontSize: '10pt', paddingLeft: '15px' }}>
                                                <Text style={{ marginBottom: '5pt', fontSize: '12pt' }}>Dados do Cliente</Text>
                                                <Text style={{ marginBottom: '5pt' }}>Nome: {values.cliente.nome}</Text>
                                                <Text style={{ marginBottom: '5pt' }}>CEP: {values.cliente.cep}</Text>
                                                <Text style={{ marginBottom: '5pt' }}>Endereço: {values.cliente.endereco}, Número: {values.cliente.numero}</Text>
                                                {!!values.cliente.complemento && <Text style={{ marginBottom: '5pt' }}>Complemento: {values.cliente.complemento}</Text>}
                                                <Text style={{ marginBottom: '5pt' }}>Celular: {values.cliente.celular} | Telefone: {values.cliente.telefone}</Text>
                                                {!!values.cliente.email && <Text style={{ marginBottom: '5pt' }}>Email: {values.cliente.email}</Text>}
                                            </View>
                                        </View>
                                        <View style={{
                                            flexDirection: "row",
                                            justifyContent: "stretch",
                                            width: "100%",
                                            display: "flex",
                                            border: "1pt solid black"
                                        }}>
                                            <View style={{ ...defaultStyle, fontSize: '10pt', paddingLeft: '15px' }}>
                                                <Text style={{ marginBottom: '5pt', fontSize: '12pt' }}>Dados da obra</Text>
                                                <Text style={{ marginBottom: '5pt' }}>CEP: {values.cep}</Text>
                                                <Text style={{ marginBottom: '5pt' }}>Endereço: {values.endereco}, Número: {values.numero}</Text>
                                                {!!values.complemento && <Text style={{ marginBottom: '5pt' }}>Complemento: {values.complemento}</Text>}
                                            </View>
                                        </View>
                                        <View style={{
                                            flexDirection: "row",

                                            width: "100%",
                                            display: "flex",
                                            border: "1pt solid black"
                                        }}>
                                            <View style={{ ...defaultStyle, width: '20%', fontSize: '10pt', fontWeight: '700', paddingLeft: '15px' }}>
                                                <Text style={{ marginBottom: '5pt' }}>Forma Pagamento</Text>
                                            </View>
                                            <View style={{ ...defaultStyle, width: '80%', fontSize: '10pt' }}>
                                                <Text style={{ marginBottom: '7pt' }}>: {values.pagamento === 'BOLETO' ? 'Boleto' : 
                                        (values.pagamento === 'CHEQUE' ? 'Cheque' : 
                                        values.pagamento === 'DINHEIRO' ? 'Dinheiro' : (
                                            values.pagamento === 'CARTAO' ? 'Cartão' : 'MERCADO_LIVRE'
                                             ))}</Text>
                                            </View>
                                        </View>
                                        <View style={{
                                                flexDirection: "row",
                                                justifyContent: "stretch",
                                                width: "100%",
                                                height: "auto",
                                                display: "flex",
                                                border: "1pt solid black"
                                            }}>
                                                <View style={{ ...defaultStyle, width: '100%', fontSize: '10pt', fontWeight: '700', paddingLeft: '15px', textAlign: 'left', borderRight: "1pt solid black" }}>
                                                <Text>Observação: {values.obs}</Text>
                                                </View>
                                            </View>
                                        <View style={{
                                            flexDirection: "row",

                                            width: "100%",
                                            display: "flex",
                                            border: "1pt solid black"
                                        }}>
                                            <View style={{ ...defaultStyle, width: '100%', fontSize: '10pt', fontWeight: '700', paddingLeft: '15px' }}>
                                                {values.informacoes.map((info, i) => <Text key={i} style={{ marginBottom: '5pt' }}>{info.nome}</Text>)}
                                            </View>
                                        </View>
                                        <View style={{
                                            flexDirection: "row",

                                            width: "100%",
                                            display: "flex",
                                            border: "1pt solid black"
                                        }}>
                                            <View style={{ ...defaultStyle, width: '10%', fontSize: '12pt', fontWeight: '700', paddingLeft: '5px', textAlign: 'left', borderRight: "1pt solid black" }}>
                                                <Text style={{ marginBottom: '2pt' }}>IT</Text>
                                            </View>
                                            <View style={{ ...defaultStyle, width: '10%', fontSize: '12pt', fontWeight: '700', paddingLeft: '5px', textAlign: 'left', borderRight: "1pt solid black" }}>
                                                <Text style={{ marginBottom: '2pt' }}>Código</Text>
                                            </View>
                                            <View style={{ ...defaultStyle, width: '80%', fontSize: '12pt', fontWeight: '700', paddingLeft: '5px', textAlign: 'left', borderRight: "1pt solid black" }}>
                                                <Text style={{ marginBottom: '2pt' }}>Descrição</Text>
                                            </View>
                                        </View>
                                        {values.servicos.map((servico, i) => {
                                            return (
                                                <View key={`${servico.codigo}-1`} style={{
                                                    flexDirection: "row",

                                                    width: "100%",
                                                    display: "flex",
                                                    border: "1pt solid black"
                                                }}>
                                                    <View style={{ ...defaultStyle, width: '10%', fontSize: '10pt', paddingLeft: '5px', textAlign: 'left', borderRight: "1pt solid black" }}>
                                                        <Text style={{ marginBottom: '2pt' }}>{i + 1}</Text>
                                                    </View>
                                                    <View style={{ ...defaultStyle, width: '10%', fontSize: '10pt', paddingLeft: '5px', textAlign: 'left', borderRight: "1pt solid black" }}>
                                                        <Text style={{ marginBottom: '2pt' }}>{servico.codigo}</Text>
                                                    </View>
                                                    <View style={{ ...defaultStyle, width: '80%', fontSize: '10pt', paddingLeft: '5px', textAlign: 'left', borderRight: "1pt solid black" }}>
                                                        <Text style={{ marginBottom: '2pt' }}>{servico.descricao}</Text>
                                                    </View>
                                                </View>
                                            )
                                        })}
                                        <View style={{
                                            position: 'absolute',
                                            bottom: 0
                                        }}>
                                            <View style={{
                                                flexDirection: "row",
                                                width: "100%",
                                                display: "flex",
                                            }}>
                                                <View style={{ ...defaultStyle, width: '50%', border: "1pt solid black", paddingTop: '30pt', fontSize: '12pt', textAlign: 'center', color: 'blue' }}>
                                                    <Text>ACEITAMOS TODOS OS CARTÕES DE CRÉDITO</Text>
                                                </View>
                                                <View style={{
                                                    display: 'flex',
                                                    flexBasis: '100%',
                                                    flexWrap: 'wrap',
                                                    wordWrap: "break-word",
                                                    whiteSpace: "pre-wrap", width: '50%', border: "1pt solid black", textAlign: 'left'
                                                }}>
                                                    <View style={{
                                                        flexDirection: "row",
                                                        display: 'flex', width: '100%', borderBottom: "1pt solid black", fontSize: '10pt', paddingLeft: '4pt'
                                                    }}>
                                                        <View style={{ width: '65%', borderRight: '1pt solid black', paddingTop: '3pt', paddingBottom: '3pt' }}><Text>SUB-TOTAL DO ORÇAMENTO</Text></View>
                                                        <View style={{ width: '35%', paddingLeft: '2pt', paddingTop: '3pt', paddingBottom: '3pt' }}><Text>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format((values.servicos.reduce((acumulador, numero, indice, original) => {
                                                            return acumulador += Number(numero.total);
                                                        }, 0)))}</Text></View>
                                                    </View>
                                                    <View style={{
                                                        flexDirection: "row",
                                                        display: 'flex', width: '100%', borderBottom: "1pt solid black", fontSize: '10pt', paddingLeft: '4pt'
                                                    }}>
                                                        <View style={{ width: '65%', borderRight: '1pt solid black', paddingTop: '3pt', paddingBottom: '3pt' }}><Text>(-) TOTAL DO DESCONTO</Text></View>
                                                        <View style={{ width: '35%', paddingLeft: '2pt', paddingTop: '3pt', paddingBottom: '3pt' }}><Text>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format((values.desconto))}</Text></View>
                                                    </View>
                                                    <View style={{
                                                        flexDirection: "row",
                                                        display: 'flex', width: '100%', borderBottom: "1pt solid black", fontSize: '10pt', paddingLeft: '4pt'
                                                    }}>
                                                        <View style={{ width: '65%', borderRight: '1pt solid black', paddingTop: '3pt', paddingBottom: '3pt' }}><Text>(+) TOTAL DO FRETE</Text></View>
                                                        <View style={{ width: '35%', paddingLeft: '2pt', paddingTop: '3pt', paddingBottom: '3pt' }}><Text>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format((values.frete))}</Text></View>
                                                    </View>
                                                    <View style={{
                                                        flexDirection: "row",
                                                        display: 'flex', width: '100%', fontSize: '10pt', paddingLeft: '4pt'
                                                    }}>
                                                        <View style={{ width: '65%', borderRight: '1pt solid black', paddingTop: '3pt', paddingBottom: '3pt' }}><Text>(=) VALOR TOTAL DO ORÇAMENTO</Text></View>
                                                        <View style={{ width: '35%', paddingLeft: '2pt', paddingTop: '3pt', paddingBottom: '3pt' }}><Text>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format((values.total))}</Text></View>
                                                    </View>
                                                </View>
                                            </View>
                                            <View style={{
                                                flexDirection: "row",
                                                width: "100%",
                                                display: "flex",
                                                border: "1pt solid black",
                                                paddingTop: '30pt',
                                                alignSelf: 'flex-end',
                                            }}>

                                                <View style={{ ...defaultStyle, width: '50%', fontSize: '12pt', fontWeight: '700', paddingLeft: '15px', textAlign: 'center' }}>
                                                    <Text>__________________________________</Text>
                                                    <Text>Aprovação do Cliente</Text>
                                                </View>
                                                <View style={{ ...defaultStyle, width: '50%', fontSize: '12pt', fontWeight: '700', paddingLeft: '15px', textAlign: 'center' }}>
                                                    <Text>__________________________________</Text>
                                                    <Text>Clanil Comércio de Plástico LTDA</Text>
                                                </View>
                                            </View>
                                        </View>
                                    </View>



                                </Page>
                            </Document>
                        </PDFViewer>
                    </Paper>
                </Grid>
            </Grid>
        </Layout>
    )
}